import styled from 'styled-components';

export const MissionContainer = styled.div<{ $itemCount: number }>`
  display: grid;
  grid-template-columns: ${({ $itemCount }) => 
    $itemCount === 1 ? 'minmax(auto, 400px)' : 
    $itemCount === 2 ? 'repeat(2, minmax(auto, 400px))' : 
    'repeat(3, 1fr)'
  };
  gap: 32px;
  width: 100%;
  justify-content: center;
  margin: 0 auto;
  max-width: ${({ $itemCount }) => 
    $itemCount === 1 ? '400px' : 
    $itemCount === 2 ? '850px' : 
    '100%'
  };

  ${({ $itemCount }) => $itemCount === 3 && `
    margin: 0;
  `}

  @media (min-width: 651px) and (max-width: 1150px) {
    grid-template-columns: ${({ $itemCount }) => 
      $itemCount === 1 ? 'minmax(auto, 400px)' : 
      'repeat(2, 1fr)'
    };
    margin: 0 auto;
    max-width: ${({ $itemCount }) => $itemCount === 1 ? '400px' : '900px'};
  }

  @media (max-width: 650px) {
    grid-template-columns: minmax(auto, 400px);
    margin: 0 auto;
    max-width: 400px;
  }
`;

export const OverflowedMission = styled.div<{ $itemCount: number }>`
  text-align: left;
  box-sizing: border-box;
  border-radius: 8px;

  @media (min-width: 768px) and (max-width: 1201px) {
    margin-left: 0 !important;
    margin-right: 0 !important;
    margin-top: 10px !important;
    width: 100%;
  }

  @media (max-width: 767px) {
    margin-left: 0 !important;
    margin-right: 0 !important;
    margin-top: 10px !important;
    width: 100%;
  }
`;

export const BenefitContainer = styled.div<{ $itemCount: number }>`
  display: grid;
  gap: 50px;
  width: 100%;
  justify-content: ${props => props.$itemCount < 4 ? 'center' : 'space-between'};
  position: relative;

  grid-template-columns: ${({ $itemCount }) => {
    if ($itemCount === 1) return '1fr';
    if ($itemCount === 2) return 'repeat(2, 1fr)';
    if ($itemCount === 3) return 'repeat(3, 1fr)';
    return 'repeat(4, 1fr)';
  }};

  ${({ $itemCount }) => $itemCount <= 3 && `
    max-width: 900px;
    margin: 0 auto;
  `}

  @media (min-width: 1200px) {
    justify-content: center;
    justify-items: center;
  }

  @media (min-width: 865px) and (max-width: 1199px) {
    grid-template-columns: repeat(3, 1fr);
    justify-items: center;
  }

  @media (min-width: 670px) and (max-width: 864px) {
    grid-template-columns: repeat(2, 1fr);
    justify-content: center;
    justify-items: center;
  }

  @media (max-width: 669px) {
    grid-template-columns: 1fr;
    justify-content: center;
    justify-items: center;
  }
`;

export const OverflowedBenefit = styled.div<{ $itemCount: number }>`
  text-align: center;
  box-sizing: border-box;
  border-radius: 8px;
  margin-top: 0px;
  height: 100%;
`;
